<script lang="ts">
  import { settings } from '../state/settings.svelte';
  import CapabilityReport from './CapabilityReport.svelte';
  import { router } from './router.svelte';
</script>

<section class="panel" data-testid="view-settings">
  <h2>Settings</h2>
  <label>
    Theme
    <select bind:value={settings.theme}>
      <option value="system">Follow system</option>
      <option value="light">Light</option>
      <option value="dark">Dark</option>
    </select>
  </label>
  <p class="hint">
    Analysis, calibration and filter settings appear here as the corresponding features arrive.
  </p>
  <p><a href={router.href('selftest')}>Run the self-test in this browser →</a></p>
</section>
<CapabilityReport />

<style>
  label {
    display: flex;
    gap: 0.6rem;
    align-items: center;
  }
  .hint {
    color: var(--muted);
    font-size: 0.9rem;
  }
</style>
